angular.module('tf.translations')
.constant('LANG_EN',{
        "templatefarm"  :"Template Farm",
        "whatsthis"     :"What's This?",
        "documentation" :"Documentation",
        "contact"       :"Contact",
        "features"      :"Features",
        "logout"        :"Logout",
        "plans"         :"Plans",
        "pricing"       :"Pricing",
        "home"          :"Home",
        "taskManager"   :"Task Manager",
        "task"          :"Task",
        "status"        :"Status",
        "progress"      :"Progress",
        "menu"          :"Menu",
        "statistics"    :"Statistics",
        "history"       :"History",
        "schedule"      :"Schedule",
        "dashboard"     :"Dashboard",
        "users"         :"Users",
        "help"          :"Help",
        "explore"       :"Explore",
        "project-settings":"Project Settings",
        "notifications" : {
            "resetPasswordEmailSuccess" : "Please check your email to reset your password!!",
            "shareEmailSuccess" : "An email has been sent to the users",
            "confirmExitTitle": "You have made changes to this project",
            "confirmExitContent": "If you leave without producing your changes will be lost",
            "confirmSettingsExitTitle": "You have made changes in the settings",
            "confirmSettingsExitContent": "If you leave without saving your changes will be lost",
            "confirmProjectResetTitle": "Reset Project",
            "confirmProjectResetContent": "Are you sure you want to reset the project to it's original values?"
        }
});
